import React from "react";
import Todo from "./page";

function App() {
  return <Todo />;
}

export default App;
